import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "p-12" };
const _hoisted_2 = { class: "mb-4" };
const _hoisted_3 = { class: "text-lg leading-6 font-medium text-gray-900" };
const _hoisted_4 = /*#__PURE__*/ _createElementVNode("p", { class: "mt-4 text-sm text-gray-500" }, [
    /*#__PURE__*/ _createElementVNode("b", null, "* Please ensure that all mandatory fields are completed and the\n              Job Description has been attached before submitting for\n              approval")
], -1);
const _hoisted_5 = {
    class: "p-5 my-8 bg-slate-200",
    style: { "border-radius": "20px" }
};
const _hoisted_6 = { class: "bg-white shadow overflow-hidden sm:rounded-lg" };
const _hoisted_7 = /*#__PURE__*/ _createElementVNode("div", { class: "px-4 py-5 sm:px-6" }, [
    /*#__PURE__*/ _createElementVNode("h3", { class: "text-lg leading-6 font-medium text-gray-900" }, "ATR Information")
], -1);
const _hoisted_8 = { class: "border-t border-gray-200 px-4 py-5 sm:p-0" };
const _hoisted_9 = { class: "sm:divide-y sm:divide-gray-200" };
const _hoisted_10 = { class: "py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6" };
const _hoisted_11 = /*#__PURE__*/ _createElementVNode("dt", { class: "text-sm font-medium text-gray-500" }, "Employee Name", -1);
const _hoisted_12 = { class: "mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2" };
const _hoisted_13 = { class: "py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6" };
const _hoisted_14 = /*#__PURE__*/ _createElementVNode("dt", { class: "text-sm font-medium text-gray-500" }, "Hiring manager", -1);
const _hoisted_15 = { class: "mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2" };
const _hoisted_16 = { class: "py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6" };
const _hoisted_17 = /*#__PURE__*/ _createElementVNode("dt", { class: "text-sm font-medium text-gray-500" }, "Hiring manager email", -1);
const _hoisted_18 = { class: "mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2" };
const _hoisted_19 = { class: "py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6" };
const _hoisted_20 = /*#__PURE__*/ _createElementVNode("dt", { class: "text-sm font-medium text-gray-500" }, "Status", -1);
const _hoisted_21 = { class: "mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2" };
const _hoisted_22 = { class: "py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6" };
const _hoisted_23 = /*#__PURE__*/ _createElementVNode("dt", { class: "text-sm font-medium text-gray-500" }, "Job title", -1);
const _hoisted_24 = { class: "mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2" };
const _hoisted_25 = { class: "py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6" };
const _hoisted_26 = /*#__PURE__*/ _createElementVNode("dt", { class: "text-sm font-medium text-gray-500" }, "Attachments", -1);
const _hoisted_27 = { class: "mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2" };
const _hoisted_28 = {
    key: 0,
    role: "list",
    class: "border border-gray-200 rounded-md divide-y divide-gray-200"
};
const _hoisted_29 = { class: "w-0 flex-1 flex items-center" };
const _hoisted_30 = { class: "ml-2 flex-1 w-0 truncate" };
const _hoisted_31 = { class: "ml-4 flex-shrink-0" };
const _hoisted_32 = ["onClick"];
const _hoisted_33 = { key: 1 };
const _hoisted_34 = {
    class: "p-5 my-8 bg-slate-200",
    style: { "border-radius": "20px" }
};
const _hoisted_35 = { class: "bg-white shadow overflow-hidden sm:rounded-lg" };
const _hoisted_36 = { class: "border-t border-gray-200 px-4 py-5 sm:p-0" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_PaperClipIcon = _resolveComponent("PaperClipIcon");
    const _component_approval_form = _resolveComponent("approval-form");
    const _component_reject_form = _resolveComponent("reject-form");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", null, [
            _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("h3", _hoisted_3, "\n            Approve " + _toDisplayString(_ctx.formData.docId), 1),
                    _createTextVNode(),
                    _hoisted_4
                ])
            ])
        ]),
        _createTextVNode(),
        _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
                _hoisted_7,
                _createTextVNode(),
                _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("dl", _hoisted_9, [
                        _createElementVNode("div", _hoisted_10, [
                            _hoisted_11,
                            _createTextVNode(),
                            _createElementVNode("dd", _hoisted_12, _toDisplayString(_ctx.formData.formOne.employeeName), 1)
                        ]),
                        _createTextVNode(),
                        _createElementVNode("div", _hoisted_13, [
                            _hoisted_14,
                            _createTextVNode(),
                            _createElementVNode("dd", _hoisted_15, _toDisplayString(_ctx.formData.formOne.hiringManagerName), 1)
                        ]),
                        _createTextVNode(),
                        _createElementVNode("div", _hoisted_16, [
                            _hoisted_17,
                            _createTextVNode(),
                            _createElementVNode("dd", _hoisted_18, _toDisplayString(_ctx.formData.formOne.hiringManagerEmail), 1)
                        ]),
                        _createTextVNode(),
                        _createElementVNode("div", _hoisted_19, [
                            _hoisted_20,
                            _createTextVNode(),
                            _createElementVNode("dd", _hoisted_21, _toDisplayString(_ctx.formData.status), 1)
                        ]),
                        _createTextVNode(),
                        _createElementVNode("div", _hoisted_22, [
                            _hoisted_23,
                            _createTextVNode(),
                            _createElementVNode("dd", _hoisted_24, _toDisplayString(_ctx.formData.formThree.jobTitle), 1)
                        ]),
                        _createTextVNode(),
                        _createElementVNode("div", _hoisted_25, [
                            _hoisted_26,
                            _createTextVNode(),
                            _createElementVNode("dd", _hoisted_27, [
                                (_ctx.formData.formEleven.files?.length)
                                    ? (_openBlock(), _createElementBlock("ul", _hoisted_28, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formData.formEleven.files, (file, index) => {
                                            return (_openBlock(), _createElementBlock("li", {
                                                key: file.name,
                                                class: "pl-3 pr-4 py-3 flex items-center justify-between text-sm"
                                            }, [
                                                _createElementVNode("div", _hoisted_29, [
                                                    _createVNode(_component_PaperClipIcon, {
                                                        class: "flex-shrink-0 h-5 w-5 text-gray-400",
                                                        "aria-hidden": "true"
                                                    }),
                                                    _createTextVNode(),
                                                    _createElementVNode("span", _hoisted_30, _toDisplayString(file.name), 1)
                                                ]),
                                                _createTextVNode(),
                                                _createElementVNode("div", _hoisted_31, [
                                                    _createElementVNode("button", {
                                                        class: "font-medium text-indigo-600 hover:text-indigo-500",
                                                        onClick: _withModifiers(($event) => (_ctx.handleDownload(index)), ["prevent"])
                                                    }, " Download ", 8, _hoisted_32)
                                                ])
                                            ]));
                                        }), 128))
                                    ]))
                                    : (_openBlock(), _createElementBlock("span", _hoisted_33, "-"))
                            ])
                        ])
                    ])
                ])
            ])
        ]),
        _createTextVNode(),
        _createElementVNode("div", _hoisted_34, [
            _createElementVNode("div", _hoisted_35, [
                _createElementVNode("div", _hoisted_36, [
                    (_ctx.form_to_show === '1')
                        ? (_openBlock(), _createBlock(_component_approval_form, {
                            key: 0,
                            sla: _ctx.secondApprover
                        }, null, 8, ["sla"]))
                        : (_ctx.form_to_show === '2')
                            ? (_openBlock(), _createBlock(_component_reject_form, {
                                key: 1,
                                atr: _ctx.formData
                            }, null, 8, ["atr"]))
                            : _createCommentVNode("", true)
                ])
            ])
        ])
    ]));
}
